const AwardPointsComponent = (props) => {
  const { customComponentName, definition } = props;

  const points =
    definition?.outcomeDefinition?.outcomeRules?.[0]?.ruleData?.points ||
    definition?.outcomeRules?.[0]?.ruleData?.points;
  // Format the component name from "abc-def-ghi" to "Abc Def Ghi"
  const formatComponentName = (name) => {
    if (!name) return "";

    return name
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const formattedName = formatComponentName(customComponentName);

  return (
    <div className="additional-fields-container">
      <h5>
        {formattedName || "Unknown Component"}: {points}
      </h5>
    </div>
  );
};

export default AwardPointsComponent;
